export const TOUCH = "(pointer: coarse)";
export const INSTALLED = "(display-mode: standalone)";

/** U-18: the Sync badge shows on a phone; on another device only when an entry is not saved. */
export function showSyncBadge(count: number, failed: boolean, phone: boolean): boolean {
  return count > 0 && (phone || failed);
}
